const card = {
  vacantes: {
    disponible: 'Vacante disponible',
    disponibles: 'Vacantes disponibles',
  },
}

export default card
